import React from "react";

function Payment({
  onKeyPress,
  showLetters,
  setShowLetters,
  context,
}) {
  const numbers =
    context === "numeric"
      ? Array.from("123456789-0.")
      : Array.from("123456789-0_");
  const letters = Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
  const keysToShow = showLetters ? letters : numbers;

  const handleKeyClick = (key) => {
    onKeyPress(key);
  };

  return (
    <div className="pos-calc-container">
      <div
        className="pos-calc-grid"
        style={{
          gridTemplateColumns: showLetters
            ? "repeat(6, 1fr)"
            : "repeat(3, 1fr)",
        }}
      >
        {keysToShow.map((key) => (
          <button className="btn btn-secondary" key={key} onClick={() => handleKeyClick(key)}>
            {key}
          </button>
        ))}
        {context === "numeric" ? (
          <button onClick={() => handleKeyClick("%")}>%</button>
        ) : (
          <button
            className="toggle-keyboard"
            onClick={() => setShowLetters(!showLetters)}
          >
            <i className="fa fa-keyboard"></i>
          </button>
        )}
        <button onClick={() => handleKeyClick("←")}>←</button>
        {context === "numeric" ? (
          <button onClick={() => handleKeyClick("prix")}>Prix</button>
        ) : (
          <button onClick={() => handleKeyClick("✔")}>✔</button>
        )}
      </div>
    </div>
  );
}

export default Payment;
